/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangeEmailRequest } from '../models/ChangeEmailRequest';
import type { ChangePasswordRequest } from '../models/ChangePasswordRequest';
import type { RequestResetPasswordRequest } from '../models/RequestResetPasswordRequest';
import type { ResendEmailConfirmationRequest } from '../models/ResendEmailConfirmationRequest';
import type { ResendEmailConfirmationResponse } from '../models/ResendEmailConfirmationResponse';
import type { ResetPasswordRequest } from '../models/ResetPasswordRequest';
import type { SignupRequest } from '../models/SignupRequest';
import type { SignupResponse } from '../models/SignupResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccountService {
    /**
     * TEMP: Creates a new user.
     * TEMP: signs up a new user. That's a temporary endpoint and will be removed as soon we'll have enough endpoints to manage users.
     * @param requestBody
     * @returns SignupResponse Success
     * @throws ApiError
     */
    public static signupEndpoint(
        requestBody: SignupRequest,
    ): CancelablePromise<SignupResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/account/signup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation failed.`,
            },
        });
    }
    /**
     * Reset a user's password.
     * Allows a user to reset their password by providing the necessary details, such as token, email and the new password.
     * @param requestBody
     * @returns any The password has been reset successfully.
     * @throws ApiError
     */
    public static resetPasswordEndpoint(
        requestBody: ResetPasswordRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/account/reset-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The provided data is invalid, or the passwords do not match.`,
                404: `The specified user was not found.`,
            },
        });
    }
    /**
     * Resend email confirmation if the email is not confirmed.
     * Allows the user to resend the email confirmation link if the email is not confirmed.
     * @param requestBody
     * @returns ResendEmailConfirmationResponse Success
     * @throws ApiError
     */
    public static resendEmailConfirmationEndpoint(
        requestBody: ResendEmailConfirmationRequest,
    ): CancelablePromise<ResendEmailConfirmationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/account/resend-email-confirmation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request if email is invalid or user is already confirmed.`,
            },
        });
    }
    /**
     * Reset a user's password.
     * Allows a user to reset their password by providing the necessary details, such as token, email and the new password.
     * @param requestBody
     * @returns any The password has been reset successfully.
     * @throws ApiError
     */
    public static requestResetPasswordEndpoint(
        requestBody: RequestResetPasswordRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/account/request-reset-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The provided data is invalid, or the passwords do not match.`,
                404: `The specified user was not found.`,
            },
        });
    }
    /**
     * Email confirmation
     * This endpoint confirms the user's email using the provided token. Values should be URL encoded if contains special characters.
     * @param email
     * @param token
     * @param shouldSendResetPasswordEmail
     * @returns any Success
     * @throws ApiError
     */
    public static emailConfirmationEndpoint(
        email: string,
        token: string,
        shouldSendResetPasswordEmail?: boolean | null,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/account/confirm-email',
            query: {
                'email': email,
                'token': token,
                'shouldSendResetPasswordEmail': shouldSendResetPasswordEmail,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Endpoint to change a user's password.
     * This endpoint allows a user to update their password. The request requires the current password,
     * a new password, and a confirmation of the new password.
     * @param requestBody
     * @returns any The password has been updated successfully.
     * @throws ApiError
     */
    public static changePasswordEndpoint(
        requestBody: ChangePasswordRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/account/change-password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The provided input is invalid or missing required fields.`,
                401: `The current password is incorrect.`,
                404: `The user could not be found.`,
            },
        });
    }
    /**
     * Endpoint to change a user's email address.
     * This endpoint allows updating a user's email address in the system. The request requires the current email, the new email, and a confirmation token.
     * @param requestBody
     * @returns any The email address has been updated successfully.
     * @throws ApiError
     */
    public static changeEmailEndpoint(
        requestBody: ChangeEmailRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/account/change-email',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The provided input is invalid or missing required fields.`,
                404: `The user associated with the specified email could not be found.`,
            },
        });
    }
}
